import { render, staticRenderFns } from "./blok-column.vue?vue&type=template&id=a9ba0604&scoped=true&"
import script from "./blok-column.vue?vue&type=script&lang=js&"
export * from "./blok-column.vue?vue&type=script&lang=js&"
import style0 from "./blok-column.vue?vue&type=style&index=0&id=a9ba0604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba0604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9ba0604')) {
      api.createRecord('a9ba0604', component.options)
    } else {
      api.reload('a9ba0604', component.options)
    }
    module.hot.accept("./blok-column.vue?vue&type=template&id=a9ba0604&scoped=true&", function () {
      api.rerender('a9ba0604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-column.vue"
export default component.exports